export { showGenericError } from './helperFunctions'

export const VIMEO_URL_PATTERN = /^https:\/\/(www\.|player\.)?vimeo\.com\/(video\/)?(\d+)(\/([a-z0-9]+))?([/?#]\S*)?$/i

export const vimeoEmbedUrl = (url) => {
  const match = (url || '').trim().match(VIMEO_URL_PATTERN)
  if (!match) { return null }

  return match[5] ? `https://player.vimeo.com/video/${match[3]}?h=${match[5]}` : `https://player.vimeo.com/video/${match[3]}`
}

export const lessonHasContent = (lesson) => !!lesson.vimeoEmbedUrl || (lesson.body || '').trim() !== ''

export const isPercentage = (value) => Number.isInteger(Number(value)) && Number(value) >= 1 && Number(value) <= 100

export const formatAmount = (price) => `${price.currency.symbol}${Number(price.amount).toFixed(2)} ${price.currency.code.toUpperCase()}`

export const blurOnEnter = (e) => e.key === 'Enter' && e.target.blur()

export const curriculumTotals = (sections) => ({
  sections: sections.length,
  lessons: sections.reduce((count, section) => count + section.lessons.length, 0),
})

const isPublished = (lesson) => !lesson.draft

export const publishChecklist = (certification) => {
  const { sections } = certification
  const publishedLessons = sections.flatMap(section => section.lessons).filter(isPublished)

  return [
    { key: 'curriculum', done: sections.length > 0 && sections.every(section => section.lessons.some(isPublished)), ...curriculumTotals(sections) },
    { key: 'lessonsContent', done: publishedLessons.length > 0 && publishedLessons.every(lessonHasContent) },
    { key: 'finalQuiz', done: certification.finalQuiz.questions.length > 0, count: certification.finalQuiz.questions.length },
    { key: 'defaultPrice', done: certification.prices.some(price => !price.organization) },
    { key: 'accolade', done: !!certification.accolade },
  ]
}

export const isPublishable = (certification) => publishChecklist(certification).every(item => item.done)

export const questionErrors = (question) => {
  const answers = question.answers.filter(answer => !answer._destroy)
  const errors = {}

  if (question.prompt.trim() === '') { errors.prompt = 'prompt' }
  if (answers.length < 2 || answers.some(answer => answer.text.trim() === '')) {
    errors.answers = 'answersText'
  } else if (answers.filter(answer => answer.correct).length !== 1) {
    errors.answers = 'answersCorrect'
  }

  return errors
}

export const answersAttributes = (answers) => answers
  .filter(answer => answer.id || !answer._destroy)
  .map(answer => answer._destroy ? { id: answer.id, _destroy: true } : { id: answer.id, text: answer.text.trim(), correct: answer.correct })

export const bulletsFromText = (text) => text.split('\n').map(line => line.trim()).filter(line => line !== '')
